import { pushSubscriptions } from '@markku/db'
import { createInsertSchema, createSelectSchema } from 'drizzle-zod'
import { z } from 'zod'

export const selectPushSubscriptionSchema =
  createSelectSchema(pushSubscriptions)

export const insertPushSubscriptionSchema = createInsertSchema(
  pushSubscriptions,
)
  .omit({
    id: true,
    createdAt: true,
    updatedAt: true,
    deletedAt: true,
    initialTokenId: true, // initialTokenId is extracted from authenticated user's refresh token
  })
  .extend({
    endpoint: z.string().url(),
    p256dhKey: z.string().min(1),
    authKey: z.string().min(1),
  })

export type PushSubscription = z.infer<typeof selectPushSubscriptionSchema>
export type CreatePushSubscription = z.infer<
  typeof insertPushSubscriptionSchema
>
